import { render, staticRenderFns } from "./ProjectsJobs.vue?vue&type=template&id=18b8a3ac&scoped=true&"
import script from "./ProjectsJobs.vue?vue&type=script&lang=js&"
export * from "./ProjectsJobs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsJobs.vue?vue&type=style&index=0&id=18b8a3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8a3ac",
  null
  
)

export default component.exports